<template>
  <div class="item-container" :class="{ 'is-active': isActive, 'fold-active': fold && isActive }">
    <div class="icon-container" :class="{ 'is-hide-icon': !icon }">
      <svg-icon :name="icon" class="icon default-icon" />
      <svg-icon :name="'active-' + icon" class="icon active-icon" />
      <svg-icon v-show="title === 'Messaging' && sessionsUnread > 0" name="dot-v2" class="dot-icon" />
      <svg-icon v-show="title === 'Payments' && !peymentViewed" name="dot-v3" class="dot-icon" />
    </div>
    <div class="item-title-box">
      <span class="item-title overflow-management">{{ title }}</span>
      <svg-icon v-if="tag" class="item-tag" :name="tag" :style="tagStyle" />
    </div>
    <svg-icon v-if="isNest" :class="{ 'is-unfold': isUnfold }" name="down-v2" class="down-icon" />
    <svg-icon v-if="!isNest && isLock" name="Unlock(1)" class='unlock-icon'></svg-icon>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";

export default {
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    tag: {
      type: String,
      default: ''
    },
    isNest: { // 是否展示下拉图标
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: false
    },
    isUnfold: { // 控制下拉图标状态
      type: Boolean,
      default: false
    },
    fold: {
      type: Boolean,
      default: false,
    },
    isLock: {
      type: Boolean,
      default: false,
    },
    meta: null
  },
  data() {
    return {
    }
  },
  mounted() {
    let hasViewedPayments = localStorage.getItem(`has_reviewed_payments_${this.userId}`)
    this.peymentViewed = hasViewedPayments === 'YES'
  },
  computed: {
    ...mapGetters("im", ["sessionsUnread"]),
    ...mapState({
      userId: (state) => state.user.userId,
    }),
    tagStyle() {
      let _style = {}
      let meta = this.meta || {}
      if (meta.tagWidth) {
        _style.width = meta.tagWidth
      }
      if (meta.tagHeight) {
        _style.height = meta.tagHeight
      }
      return _style
    }
  },
}
</script>
<style lang="scss" scoped>
.item-container {
  width: 100%;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  overflow: hidden;

  // margin-right: 12px;
  &:hover {
    .default-icon {
      display: none;
    }

    .active-icon {
      display: inline-block;
    }

    .item-title {
      color: #FFF;
    }
  }

  &.is-active {
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 0.15);

    .default-icon {
      display: none;
    }

    .active-icon {
      display: inline-block !important;
    }

    .item-title {
      color: #ffffff;
    }
  }

  &.fold-active {
    background: none;
    border-radius: 0;
  }

  .icon-container {
    position: relative;
    margin-right: 10px;
    flex-shrink: 0;
    font-size: 0;
    min-height: 24px;

    &.is-hide-icon {
      height: 0;
    }

    .dot-icon {
      position: absolute;
      top: -2px;
      right: -2px;
      font-size: 10px;
    }
  }

  .icon {
    font-size: 24px;
  }

  .active-icon {
    display: none;
  }

  .item-title-box {
    flex: 1;
    overflow: hidden;
    display: flex;
    align-items: center;

    .item-title {
      font-family: OpenSans;
      font-weight: 700;
      font-size: 12px;
      color: #a4b4d0;
      text-align: left;
      line-height: 16px;
    }

    .item-tag {
      margin-left: 4px;
    }
  }

  .down-icon {
    // margin-left: 10px;
    flex-shrink: 0;
    font-size: 16px;
    color: #ffffff;
    transition: 0.2s transform ease-in-out;

    &.is-unfold {
      transform: rotateZ(180deg);
    }
  }

  .unlock-icon {
    margin-left: 10px;
    flex-shrink: 0;
    font-size: 16px;
  }
}</style>
